/**
 * @author Hiroki Moto
 */

import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import EditDropdown from '@components/EditDropdown';
import BasicShow from '../Products/BasicShow';
import Recent from '../Products/Recent';
import Others from '../Products/Others';

const Basic = ({ data, company, businessId, onEdit, onDetail, products, logo }) => {
    const categories = useSelector((state) => state.vendor.categories.all);
    const categoryProducts = find(propEq('id', data.category?.id ? data?.category?.id : data?.data?.category), categories)?.popular;
    return (
        <>
            <div className="card position-relative">
                <BasicShow data={data} categories={categories} title={data.name} onDetail={onDetail} />
                <EditDropdown className="edit-all" options={['Edit', 'Reports']} onChange={onEdit(data)} />
            </div>
            <div className="d-flex mt-3 flex-md-row flex-column">
                <div className="d-flex-2 me-md-2">
                    <div className="card">
                        <Recent data={data} company={company} businessId={businessId} />
                    </div>
                </div>
                <div className="other-products d-flex-1 ms-md-2">
                    <div className="card">
                        <Others data={categoryProducts?.data ?? []} onDetail={onDetail} logo={logo} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default memo(Basic);
